import { Component, OnInit, Inject } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material';
import { travelItineraryUrl, travelAuthorUrl, TRAVELTYPE, BOOKINGTYPE, BOOKINGMETHOD} from 'src/app/modules/shared/common/api';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/modules/login/services/auth/auth.service';
import { ItineraryService } from 'src/app/modules/shared/services/itinerary/itinerary.service';
import { AddressService } from '../../services/address/address.service';
import { LookUpLocationComponent } from '../look-up-location/look-up-location.component';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';


@Component({
  selector: 'app-itinerary-details',
  templateUrl: './itinerary-details.component.html',
  styleUrls: ['./itinerary-details.component.scss']
})

export class ItineraryDetailsComponent implements OnInit {

  travel: Travel;
  user: User;
  travelData: any;
  expensesList:any;
  itineraryId:any;
  detailTotal:any;
  detail:any;
  currentDate:any;
  vatOption:any;
  formGroup: FormGroup;
  travel_itinerary_details: FormArray;
  loading:boolean;
  type_module:any;
  displayBtn:boolean = false;;
  total = 0;
  mode: 0;
  type = "LQ Amount";
  headerLabel = "Liquidation"
  status: Number;
  dialogConfig:any;
  supplier= [];
  detail_id = 0;
  listDetail = []; // liquidaition or Reimbursement
  supplierValue: any
  isEmpty: any;

  item={};
  misc={}

  tin_supplier = [];
  miscObj = [];
  view_supplier = [];
  accomodation_tin: string;
  representation_tin: string;
  miscellaneous_tin: string;
  per_diem_tin: string;
  meal_tin: string;


  billOption = ["Store Support Center","Requestor"];

  bookedOption = BOOKINGTYPE;
  bookedMethod = BOOKINGMETHOD;
  travelType = TRAVELTYPE;

  filterSupplier: Observable<string[]>[] = [];
  filterMisc: Observable<string[]>[] = [];
  filterAccomodation: Observable<string[]>;
  filterMeal: Observable<string[]>;
  filterPerDiem: Observable<string[]>;
  filterRepresentation: Observable<string[]>;
  filtermiscellaneous: Observable<string[]>;

  constructor(
    public dialogRef: MatDialogRef<ItineraryDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    public auth: AuthService,
    public address: AddressService,
    private itineraryService: ItineraryService,
    public dialog: MatDialog
  ) {  }

  ngOnInit() {
    this.travel = new Travel({});
    this.user = new User(this.auth.getAuthUser());
    this.travelData = this.data;
    this.formGroup = this.formBuilder.group({
      module_id:['',null],
      date_filed:['',null],
      cash_advance_id:['',null],
      travel_itinerary_id:['',null],
      itinerary_date: ['',null],
      travel_authorization_no: ['',null],
      travel_authorization_id: ['',null],
      complete_name:['',null],
      employee_id_no: ['',null],
      position: ['',null],
      department: ['',null],
      area_covered: ['',null],
      payroll_acct_no: ['',null],
      travel_type: ['',null],
      copy_date: ['',null],
      purpose: ['',null],
      location: ['',null],
      nature: ['',null],
      inclusive_date_from: ['',null],
      inclusive_date_to: ['',null],
      representation:['',null],
      miscellaneous:['',null],
      currency: ['',null],
      amount: ['',null],
      charged_to: ['',null],
      booked_by: ['',null],
      bill_to: ['',null],
      is_draft: ['',null],
      accommodation_cost: ['',null],
      currency_category: ['',null],
      charged_to_category: ['',null],
      total_transportation_cost:['',null],
      travel_itinerary_details: this.formBuilder.array([ ]),
      is_lunch:['',null],
      is_dinner:['',null],
      is_breakfast: ['',null],
      meal:['',null],
      per_diem:['',null],
      travel_summary_detail_id: ['',null],
      transportation_reason: ['',null],
      transportation: ['',null],
      per_diem_reason: ['',null],
      meal_reason: ['',null],
      total:['',null],
      accomodation_reason: ['',null],
      reason:['',null],
      accomodation_amount: ['',null],
      accomodation_amount_vat: ['',null],
      accomodation_increase_reason: ['',null],
      accomodation_supplier: ['',null],
      accomodation_tin: ['',null],
      representation_amount: ['',null],
      representation_amount_vat: ['',null],
      representation_increase_reason: ['',null],
      miscellaneous_amount: ['',null],
      miscellaneous_amount_vat: ['',null],
      miscellaneous_increase_reason: ['',null],
      per_diem_amount: ['',null],
      per_diem_amount_vat: ['',null],
      per_diem_increase_reason: ['',null],
      meal_amount: ['',null],
      reimbursement_id: ['',null],
      meal_amount_vat:['',null],
      meal_increase_reason: ['',null],
      per_diem_supplier:['',null],
      per_diem_tin:['',null],
      meal_supplier:['',null],
      meal_tin:['',null],
      reason_for_increase:['',null],
      misc:this.formBuilder.array([]),
      booking_type_itinerary:['',null],
      booking_method:['',null],
    });

    this.currentDate = this.data.res.itinerary_date;
    this.itineraryService.url = this.data.url;
    this.address.getVat().subscribe(res=>{
      this.vatOption = res;
    });

    if (this.data.cash_id) {
      this.formGroup.controls['cash_advance_id'].setValue(this.data.cash_id);
    }

    if (this.data.module_id) {
      this.formGroup.controls['module_id'].setValue(this.data.module_id);
    }

    this.formGroup.controls['travel_itinerary_id'].setValue(this.data.res.travel_itinerary_details[0].travel_itinerary_id);
    this.formGroup.controls['itinerary_date'].setValue(this.data.res.itinerary_date);
    this.formGroup.controls['total_transportation_cost'].setValue(this.data.res.total_transportation_cost);
    this.formGroup.controls['area_covered'].setValue(this.data.res.area_covered);
    this.formGroup.controls['bill_to'].setValue(this.data.res.bill_to);
    this.formGroup.controls['accommodation_cost'].setValue(this.data.res.accommodation_cost);
    this.formGroup.controls['per_diem'].setValue(this.data.res.per_diem);
    this.formGroup.controls['meal'].setValue(this.data.res.meal);
    this.formGroup.controls['representation'].setValue(this.data.res.representation);
    this.formGroup.controls['miscellaneous'].setValue(this.data.res.miscellaneous);
    this.formGroup.controls['is_lunch'].setValue(this.data.res.is_lunch);
    this.formGroup.controls['is_dinner'].setValue(this.data.res.is_dinner);
    this.formGroup.controls['is_breakfast'].setValue(this.data.res.is_breakfast);
    this.formGroup.controls['payroll_acct_no'].setValue(this.data.res.payroll_acct_no);
    this.formGroup.controls['booked_by'].setValue(this.data.res.booked_by);
    this.formGroup.controls['charged_to'].setValue(this.data.res.charged_to);
    this.formGroup.controls['currency'].setValue(this.data.res.currency);
    this.formGroup.controls['currency_category'].setValue(this.data.res.currency_category);
    this.formGroup.controls['charged_to_category'].setValue(this.data.res.charged_to_category);
    this.formGroup.controls['inclusive_date_from'].setValue(this.data.resinclusive_date_from);
    this.formGroup.controls['inclusive_date_to'].setValue(this.data.res.inclusive_date_to);
    this.formGroup.controls['location'].setValue(this.data.res.location);
    this.formGroup.controls['nature'].setValue(this.data.res.nature);
    this.formGroup.controls['purpose'].setValue(this.data.res.purpose);
    this.formGroup.controls['travel_type'].setValue(this.data.res.travel_type);
    this.formGroup.controls['travel_authorization_id'].setValue(this.data.res.travel_auth_id);
    //this.formGroup.controls['travel_itinerary_details'].setValue(this.data.res.travel_itinerary_details );

    this.formGroup.controls['booking_type_itinerary'].setValue(this.data.res.booking_type);
    this.formGroup.controls['booking_method'].setValue(this.data.res.booking_method);

    this.expensesList = this.data.res.travel_itinerary_details;
    this.itineraryId = this.data.res.id;
    var arrayControl = this.formGroup.get('travel_itinerary_details') as FormArray;
    this.expensesList.forEach((element,i) => {
        let elementDetail = (element.travel_itinerary_detail_reimbursement && Object.keys(element.travel_itinerary_detail_reimbursement).length > 0) ? element.travel_itinerary_detail_reimbursement : element.travel_itinerary_detail_liquidation ;
        if (elementDetail) {
          this.listDetail.push({
            id: (elementDetail.id)? elementDetail.id : '',
            itinerary_detail_id: (element.id)? element.id : '',
            supplier: (elementDetail.supplier)? elementDetail.supplier : '',
            tin: (elementDetail.tin)? elementDetail.tin : '',
            vat:(elementDetail.vat)? elementDetail.vat : '',
            amount: (elementDetail.amount || elementDetail.amount == 0)? elementDetail.amount: '' ,
            reason_for_increase: (elementDetail.reason_for_increase)? elementDetail.reason_for_increase : ''
          });
          this.tin_supplier[i] = elementDetail.tin;
          arrayControl.push(this.formBuilder.group({
            id: (elementDetail.id)? elementDetail.id : '',
            itinerary_detail_id: (element.id)? element.id : '',
            supplier: (elementDetail.supplier)? elementDetail.supplier : '',
            tin: (elementDetail.tin)? elementDetail.tin : '',
            vat:(elementDetail.vat)? elementDetail.vat : '',
            amount: (elementDetail.amount  || elementDetail.amount == 0)? elementDetail.amount: '' ,
            reason_for_increase: (elementDetail.reason_for_increase)? elementDetail.reason_for_increase : ''
          }));
        } else {
          this.listDetail.push({
            id: '',
            itinerary_detail_id: (element.id)? element.id : '',
            supplier: '',
            tin: '',
            vat:'',
            amount: '',
            reason_for_increase:  ''
          });
          this.tin_supplier[i] = '';
          arrayControl.push(this.formBuilder.group({
            id: '',
            itinerary_detail_id: (element.id)? element.id : '',
            supplier: '',
            tin: '',
            vat:'',
            amount: '',
            reason_for_increase: '',
          }));
        }
    });

    this.address.getSupplier().subscribe(result => {
      this.supplier = result;
      
      var arrayControl = this.formGroup.get('travel_itinerary_details') as FormArray;

      this.expensesList.forEach((element,i) => {
        this.filterSupplier[i] = arrayControl.at(i).get('supplier').valueChanges
        .pipe(startWith(''),
        map(val => typeof val === 'undefined' ? '' : val),
        map(val => this._filter(val)));
      });

      var miscCtrl = this.formGroup.get('misc') as FormArray;
      this.data.res.itinerary_miscellaneous.forEach((element,i) => {
        this.filterMisc[i] = miscCtrl.at(i).get('miscellaneous_supplier').valueChanges
        .pipe(startWith(''),
        map(val => typeof val === 'undefined' ? '' : val),
        map(val => this._filter(val)));
      });

      this.filterAccomodation = this.formGroup.get('accomodation_supplier').valueChanges
      .pipe(startWith(''),
      map(val => typeof val === 'undefined' ? '' : val),
      map(val => this._filter(val)));
  
      this.filterMeal = this.formGroup.get('meal_supplier').valueChanges
      .pipe(startWith(''),
      map(val => typeof val === 'undefined' ? '' : val),
      map(val => this._filter(val)));
  
  
      this.filterPerDiem = this.formGroup.get('per_diem_supplier').valueChanges
      .pipe(startWith(''),
      map(val => typeof val === 'undefined' ? '' : val),
      map(val => this._filter(val)));
  
    });


    var detail = this.formGroup.get('misc') as FormArray;
    this.data.res.itinerary_miscellaneous.forEach((element,i) => {
      this.miscObj.push({
        amount: element.amount,
        name:element.miscellaneous.name,
        miscellaneous_amount: (element.amount > 0) ? '' : 0,
        miscellaneous_amount_vat: '',
        miscellaneous_supplier: '',
        miscellaneous_tin:''
      });
      detail.push(this.formBuilder.group({
        amount: [{value: element.amount, disabled: true} ,null],
        miscellaneous_amount: (element.amount > 0) ? ['' ,null] : [0 ,null], 
        miscellaneous_amount_vat: ['',null],
        miscellaneous_supplier: ['',null],
        miscellaneous_tin: ['',null]
      }))
    });

    if (this.data.mode == 0) {
      this.formGroup.controls['misc'].patchValue(this.miscObj);
    }

    this.detail_id = (this.data.res.travel_itinerary_reimbursement)?this.data.res.travel_itinerary_reimbursement_list.id : this.data.res.travel_itinerary_liquidation_list.id ;
   
    this.formGroup.controls['employee_id_no'].setValue(this.user.employee_id);
    this.detail = this.data.res;
    this.travel = new Travel(this.data.res);
    this.travel.formGroup = this.formGroup;
    this.formGroup.controls['booking_type_itinerary'].disable();
    this.formGroup.controls['booking_method'].disable();
    this.formGroup.controls['accommodation_cost'].disable();
    this.formGroup.controls['booked_by'].disable();
    this.formGroup.controls['bill_to'].disable();
    this.formGroup.controls['meal'].disable();
    this.formGroup.controls['per_diem'].disable();
    this.formGroup.controls['is_lunch'].disable();
    this.formGroup.controls['is_dinner'].disable();
    this.formGroup.controls['is_breakfast'].disable();
    this.formGroup.controls['representation'].disable();
    this.formGroup.controls['miscellaneous'].disable();
    if (this.data.type == 'reimbursement') {
      this.type = "RB Amount";
      this.headerLabel =  "Reimbursement"
      this.detailTotal = this.data.res.travel_itinerary_reimbursement_list;
      this.formGroup.controls['reimbursement_id'].setValue(this.data.reimbursement_id);
      if (this.data.res.travel_itinerary_reimbursement_list.travel_itinerary_reimbursement_miscs) {
        this.data.res.travel_itinerary_reimbursement_list.travel_itinerary_reimbursement_miscs.forEach((element,i) => {
          (<FormArray>this.formGroup.controls['misc']).at(i).patchValue({
            miscellaneous_amount:  element.miscellaneous_amount,
            miscellaneous_amount_vat: element.miscellaneous_amount_vat,
            miscellaneous_supplier: element.miscellaneous_supplier,
            miscellaneous_tin:element.miscellaneous_tin,
          });
          this.miscObj[i].miscellaneous_tin = element.miscellaneous_tin;
        });
      }
      this.type_module = 'reimbursement';
    } else {
      this.type = "LQ Amount";
      this.headerLabel =  "Liquidation"
      this.data.type = 'liquidation'
      this.detailTotal = this.data.res.travel_itinerary_liquidation_list;

      if (this.data.res.travel_itinerary_liquidation_list.travel_itinerary_liquidation_miscs) {
        this.data.res.travel_itinerary_liquidation_list.travel_itinerary_liquidation_miscs.forEach((element,i) => {
          (<FormArray>this.formGroup.controls['misc']).at(i).patchValue({
            miscellaneous_amount:  element.miscellaneous_amount,
            miscellaneous_amount_vat: element.miscellaneous_amount_vat,
            miscellaneous_supplier: element.miscellaneous_supplier,
            miscellaneous_tin:element.miscellaneous_tin,
          });
          this.miscObj[i].miscellaneous_tin = element.miscellaneous_tin;
          this.miscObj[i].miscellaneous_amount = element.miscellaneous_amount ? element.miscellaneous_amount : '';
        });
      }
      this.type_module = 'liquidation';
    }

    if (this.data.mode == 1) {
      this.formGroup.controls['per_diem_reason'].setValue(this.detailTotal.per_diem_reason);
      this.formGroup.controls['meal_reason'].setValue(this.detailTotal.meal_reason);
      this.formGroup.controls['accomodation_reason'].setValue(this.detailTotal.accomodation_reason);
      this.formGroup.controls['accomodation_amount_vat'].setValue(this.detailTotal.accomodation_amount_vat);
      this.formGroup.controls['accomodation_amount'].setValue(this.detailTotal.accomodation_amount);
      this.formGroup.controls['accomodation_increase_reason'].setValue(this.detailTotal.accomodation_increase_reason);
      this.formGroup.controls['representation_amount'].setValue(this.detailTotal.representation_amount);
      this.formGroup.controls['representation_amount_vat'].setValue(this.detailTotal.representation_amount_vat);
      this.formGroup.controls['representation_increase_reason'].setValue(this.detailTotal.representation_increase_reason);
      this.formGroup.controls['miscellaneous_amount'].setValue(this.detailTotal.miscellaneous_amount);
      //this.formGroup.controls['miscellaneous_amount_vat'].setValue(this.detailTotal.miscellaneous_amount_vat);
      this.formGroup.controls['miscellaneous_increase_reason'].setValue(this.detailTotal.miscellaneous_increase_reason);
      this.formGroup.controls['per_diem_amount'].setValue(this.detailTotal.per_diem_amount);
      this.formGroup.controls['per_diem_amount_vat'].setValue(this.detailTotal.per_diem_amount_vat);
      this.formGroup.controls['per_diem_increase_reason'].setValue(this.detailTotal.per_diem_increase_reason);
      this.formGroup.controls['meal_amount'].setValue(this.detailTotal.meal_amount);
      this.formGroup.controls['meal_amount_vat'].setValue(this.detailTotal.meal_amount_vat);
      this.formGroup.controls['meal_increase_reason'].setValue(this.detailTotal.meal_increase_reason);

      this.formGroup.controls['accomodation_supplier'].setValue(this.detailTotal.accomodation_supplier);
      this.formGroup.controls['accomodation_tin'].setValue(this.detailTotal.accomodation_tin);
      this.formGroup.controls['per_diem_supplier'].setValue(this.detailTotal.per_diem_supplier);
      this.formGroup.controls['per_diem_tin'].setValue(this.detailTotal.per_diem_tin);
      this.formGroup.controls['meal_supplier'].setValue(this.detailTotal.meal_supplier);
      this.formGroup.controls['meal_tin'].setValue(this.detailTotal.meal_tin);
      // this.formGroup.controls['representation_supplier'].setValue(this.detailTotal.representation_supplier);
      // this.formGroup.controls['representation_tin'].setValue(this.detailTotal.representation_tin);
      // this.formGroup.controls['miscellaneous_supplier'].setValue(this.detailTotal.miscellaneous_supplier);
      // this.formGroup.controls['miscellaneous_tin'].setValue(this.detailTotal.miscellaneous_tin);
      this.formGroup.controls['reason_for_increase'].setValue(this.detailTotal.reason_for_increase);

      this.accomodation_tin = this.detailTotal.accomodation_tin;
      this.per_diem_tin = this.detailTotal.per_diem_tin;
      this.meal_tin = this.detailTotal.meal_tin;
      this.representation_tin = this.detailTotal.representation_tin;
      this.miscellaneous_tin = this.detailTotal.miscellaneous_tin;

      this.travel.disableForm();
    } else {
      this.formGroup.controls['accomodation_reason'].setValue(this.detailTotal.accomodation_reason);
      this.formGroup.controls['accomodation_amount'].setValue(this.detailTotal.accomodation_amount);
      this.formGroup.controls['accomodation_amount_vat'].setValue(this.detailTotal.accomodation_amount_vat);
      this.formGroup.controls['accomodation_supplier'].setValue(this.detailTotal.accomodation_supplier);
      this.formGroup.controls['accomodation_tin'].setValue(this.detailTotal.accomodation_tin);
      this.formGroup.controls['accomodation_increase_reason'].setValue(this.detailTotal.accomodation_increase_reason);

      this.formGroup.controls['per_diem_amount'].setValue(this.detailTotal.per_diem_amount);
      this.formGroup.controls['per_diem_amount_vat'].setValue(this.detailTotal.per_diem_amount_vat);
      this.formGroup.controls['per_diem_supplier'].setValue(this.detailTotal.per_diem_supplier);
      this.formGroup.controls['per_diem_tin'].setValue(this.detailTotal.per_diem_tin);
      this.formGroup.controls['per_diem_increase_reason'].setValue(this.detailTotal.per_diem_increase_reason);

      this.formGroup.controls['meal_amount'].setValue(this.detailTotal.meal_amount);
      this.formGroup.controls['meal_amount_vat'].setValue(this.detailTotal.meal_amount_vat);
      this.formGroup.controls['meal_supplier'].setValue(this.detailTotal.meal_supplier);
      this.formGroup.controls['meal_tin'].setValue(this.detailTotal.meal_tin);
      this.formGroup.controls['meal_increase_reason'].setValue(this.detailTotal.meal_increase_reason);

      this.formGroup.controls['reason_for_increase'].setValue(this.detailTotal.reason_for_increase);

      this.accomodation_tin = this.detailTotal.accomodation_tin;
      this.per_diem_tin = this.detailTotal.per_diem_tin;
      this.meal_tin = this.detailTotal.meal_tin;
      this.representation_tin = this.detailTotal.representation_tin;
      this.miscellaneous_tin = this.detailTotal.miscellaneous_tin;

      this.displayBtn = true;
    }

    this.travel.totalExpenses = this.data.res.total_expense;
    
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';

    if(this.formGroup.get('accommodation_cost').value == 0)
      this.formGroup.controls['accomodation_amount'].setValue(0)
    if(this.formGroup.get('per_diem').value == 0)
      this.formGroup.controls['per_diem_amount'].setValue(0)
    if(this.formGroup.get('meal').value == 0)
      this.formGroup.controls['meal_amount'].setValue(0)
  }
  
  closeOnClick() {
    this.dialogRef.close('');
  }

  keypressValidateNumber(e,max) {
    const pattern = new RegExp(/\d/); // '\d'
     return pattern.test(e.key);
  }

  /**
   * Number validation on input fields
   */  
  keypressValidateNumberDecimal(e) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g);
    const rgx = /^[0-9]*\.?[0-9]*$/;
    if ((e.key == '.' && e.target.value.includes('.')) || !pattern.test(e.key)) {
      return false;
    }
    return (e.target.value.match(rgx)) ? true : false;
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      id: '',
      itinerary_detail_id: '',
      supplier: ['',Validators.required],
      tin:  ['',Validators.required],
      vat: ['',Validators.required],
      amount: ['',Validators.required],
      reason_for_increase: ''
    });
  }
  
  selectSupplier(item,formInput?:string,index?:number) {
    if (formInput.toLowerCase() == 'supplier') {
      (<FormArray>this.formGroup.get('travel_itinerary_details')).at(index).patchValue({
        supplier: item.supplier,
        tin:  item.tin,
      });
      this.tin_supplier[index] = item.tin;
    }  else if (formInput == 'miscellaneous_supplier') {
      (<FormArray>this.formGroup.get('misc')).at(index).patchValue({
        miscellaneous_supplier: item.supplier,
        miscellaneous_tin:  item.tin,
      });
      this.miscObj[index].miscellaneous_tin = item.tin;
    } else {
      let tinInput = formInput.replace('_supplier','_tin');
      this.formGroup.controls[tinInput].setValue(item.tin);
      this[tinInput] = item.tin;
    }

  }
  
  edit(){
    this.displayBtn = true;
    this.travel.enableForm();
    this.formGroup.controls['booking_type_itinerary'].disable();
    this.formGroup.controls['booking_method'].disable();
    this.formGroup.controls['accommodation_cost'].disable();
    this.formGroup.controls['booked_by'].disable();
    this.formGroup.controls['bill_to'].disable();
    this.formGroup.controls['meal'].disable();
    this.formGroup.controls['per_diem'].disable();
    this.formGroup.controls['is_lunch'].disable();
    this.formGroup.controls['is_dinner'].disable();
    this.formGroup.controls['is_breakfast'].disable();
    this.formGroup.controls['representation'].disable();
    this.formGroup.controls['miscellaneous'].disable();
    var miscControl = this.formGroup.get('misc') as FormArray;
    this.data.res.itinerary_miscellaneous.forEach((element,i) => {
      miscControl.at(i).get('amount').disable();
    });
  }

  save(){
    this.loading = true;

    var validateSupplier = [
      'accomodation_supplier',
      'per_diem_supplier',
      'meal_supplier'
    ];

    if(this.type_module == 'liquidation'){
      let transpoDetail = this.formGroup.get('travel_itinerary_details') as FormArray;
      let miscAndRep = this.formGroup.get('misc') as FormArray;
      if(this.formGroup.controls['total_transportation_cost'].value == 0 && transpoDetail.at(0).get('amount').value == 0){
        console.log('LQ trasnpo cost :', );
        transpoDetail.at(0).get('vat').setValue('DISALLOWED')
        transpoDetail.at(0).get('supplier').setValue('NO VENDOR')
        transpoDetail.at(0).get('amount').setValue(0)
        transpoDetail.at(0).get('tin').setValue('')
      }
      if(this.formGroup.controls['accommodation_cost'].value == 0 && this.formGroup.controls['accomodation_amount'].value == 0){
        console.log('LQ acc amount :', );
        this.formGroup.controls['accomodation_amount_vat'].setValue('DISALLOWED')
        this.formGroup.controls['accomodation_supplier'].setValue('NO VENDOR')
        this.formGroup.controls['accomodation_tin'].setValue('')
      }
      if(this.formGroup.controls['per_diem'].value == 0 && this.formGroup.controls['per_diem_amount'].value == 0){
        console.log('LQ per diem :', );
        this.formGroup.controls['per_diem_amount_vat'].setValue('DISALLOWED')
        this.formGroup.controls['per_diem_supplier'].setValue('NO VENDOR')
        this.formGroup.controls['per_diem_tin'].setValue('')
      }
      if(this.formGroup.controls['meal'].value == 0 && this.formGroup.controls['meal_amount'].value == 0){
        console.log('LQ meal :', );
        this.formGroup.controls['meal_amount_vat'].setValue('DISALLOWED')
        this.formGroup.controls['meal_supplier'].setValue('NO VENDOR')
        this.formGroup.controls['meal_tin'].setValue('')
      }
      if(this.formGroup.get('representation').value == 0 && this.formGroup.get('miscellaneous').value == 0 && miscAndRep.at(0).get('miscellaneous_amount').value == 0 && miscAndRep.at(1).get('miscellaneous_amount').value == 0){
        console.log('LQ misc ammout :', );
        miscAndRep.at(0).get('miscellaneous_supplier').setValue('NO VENDOR')
        miscAndRep.at(1).get('miscellaneous_supplier').setValue('NO VENDOR')
        miscAndRep.at(0).get('miscellaneous_amount_vat').setValue('DISALLOWED')
        miscAndRep.at(1).get('miscellaneous_amount_vat').setValue('DISALLOWED')
        miscAndRep.at(0).get('miscellaneous_tin').setValue('')
        miscAndRep.at(1).get('miscellaneous_tin').setValue('')
      }
    }
    else if(this.type_module == 'reimbursement'){
      let transpoDetail = this.formGroup.get('travel_itinerary_details') as FormArray;
      let miscAndRep = this.formGroup.get('misc') as FormArray;
      if(this.formGroup.controls['total_transportation_cost'].value == 0){
        console.log('RB misc ammout :', );
        transpoDetail.at(0).get('vat').setValue('DISALLOWED')
        transpoDetail.at(0).get('supplier').setValue('NO VENDOR')
        transpoDetail.at(0).get('amount').setValue(0)
        transpoDetail.at(0).get('tin').setValue('')
      }
      if(this.formGroup.controls['accommodation_cost'].value == 0){
        console.log('RB acc cost :', );
        this.formGroup.controls['accomodation_amount_vat'].setValue('DISALLOWED')
        this.formGroup.controls['accomodation_supplier'].setValue('NO VENDOR')
        this.formGroup.controls['accomodation_tin'].setValue('')
      }
      if(this.formGroup.controls['per_diem'].value == 0){
        console.log('RB per_diem :', );
        this.formGroup.controls['per_diem_amount_vat'].setValue('DISALLOWED')
        this.formGroup.controls['per_diem_supplier'].setValue('NO VENDOR')
        this.formGroup.controls['per_diem_tin'].setValue('')
      }
      if(this.formGroup.controls['meal'].value == 0){
        console.log('RB meal :', );
        this.formGroup.controls['meal_amount_vat'].setValue('DISALLOWED')
        this.formGroup.controls['meal_supplier'].setValue('NO VENDOR')
        this.formGroup.controls['meal_tin'].setValue('')
      }
      if(this.formGroup.get('representation').value == 0 && this.formGroup.get('miscellaneous').value == 0){
        console.log('RB misc and rep :', );
        miscAndRep.at(0).get('miscellaneous_supplier').setValue('NO VENDOR')
        miscAndRep.at(1).get('miscellaneous_supplier').setValue('NO VENDOR')
        miscAndRep.at(0).get('miscellaneous_amount_vat').setValue('DISALLOWED')
        miscAndRep.at(1).get('miscellaneous_amount_vat').setValue('DISALLOWED')
        miscAndRep.at(0).get('miscellaneous_tin').setValue('')
        miscAndRep.at(1).get('miscellaneous_tin').setValue('')
      }
    }

    var arrayControl = this.formGroup.get('travel_itinerary_details') as FormArray;
    this.expensesList.forEach((element,i) => {
      let validate = this._filter(arrayControl.at(i).get('supplier').value);
      if (validate) {
        if (validate[0] && (arrayControl.at(i).get('supplier').value.length != validate[0]['supplier'].length)) {
          arrayControl.at(i).get('supplier').setErrors({'invalid':true});
          arrayControl.at(i).get('supplier').markAsTouched();
          arrayControl.at(i).get('supplier').markAsDirty();
        }  else if(validate.length == 0) {
          arrayControl.at(i).get('supplier').setErrors({'invalid':true});
          arrayControl.at(i).get('supplier').markAsTouched();
          arrayControl.at(i).get('supplier').markAsDirty();
        } 
      }

      if (arrayControl.at(i).get('supplier').value == '') {
        arrayControl.at(i).get('supplier').setErrors({'invalid':true});
        arrayControl.at(i).get('supplier').markAsTouched();
        arrayControl.at(i).get('supplier').markAsDirty();            
      }
      if (arrayControl.at(i).get('vat').value == '') {
        arrayControl.at(i).get('vat').setErrors({'invalid':true});
        arrayControl.at(i).get('vat').markAsTouched();
        arrayControl.at(i).get('vat').markAsDirty();         
      }

      if (arrayControl.at(i).get('amount').value === '') {
        arrayControl.at(i).get('amount').setErrors({'invalid':true});
        arrayControl.at(i).get('amount').markAsTouched();
        arrayControl.at(i).get('amount').markAsDirty();
      }

      if (arrayControl.at(i).get('amount').value === '' && arrayControl.at(i).get('amount').value != 0) {
        arrayControl.at(i).get('amount').setErrors({'invalid':true});
        arrayControl.at(i).get('amount').markAsTouched();
        arrayControl.at(i).get('amount').markAsDirty();
      }
    });

    if(this.formGroup.get('representation').value || this.formGroup.get('miscellaneous').value != 0){
      this.isEmpty = true
      var miscControl = this.formGroup.get('misc') as FormArray;

      this.data.res.itinerary_miscellaneous.forEach((element,i) => {
      let validate = this._filter(miscControl.at(i).get('miscellaneous_supplier').value);

      if (validate) {
        if (validate[0] && (miscControl.at(i).get('miscellaneous_supplier').value.length != validate[0]['supplier'].length)) {
          miscControl.at(i).get('miscellaneous_supplier').setErrors({'invalid':true});
          miscControl.at(i).get('miscellaneous_supplier').markAsTouched();
          miscControl.at(i).get('miscellaneous_supplier').markAsDirty();
        }  else if(validate.length == 0) {
          miscControl.at(i).get('miscellaneous_supplier').setErrors({'invalid':true});
          miscControl.at(i).get('miscellaneous_supplier').markAsTouched();
          miscControl.at(i).get('miscellaneous_supplier').markAsDirty();
        }
      }

      if (miscControl.at(i).get('miscellaneous_supplier').value == '') {
        miscControl.at(i).get('miscellaneous_supplier').setErrors({'invalid':true});
        miscControl.at(i).get('miscellaneous_supplier').markAsTouched();
        miscControl.at(i).get('miscellaneous_supplier').markAsDirty();            
      }
      if (miscControl.at(i).get('miscellaneous_amount_vat').value == '') {
        miscControl.at(i).get('miscellaneous_amount_vat').setErrors({'invalid':true});
        miscControl.at(i).get('miscellaneous_amount_vat').markAsTouched();
        miscControl.at(i).get('miscellaneous_amount_vat').markAsDirty();         
      }
      if (miscControl.at(i).get('miscellaneous_amount').value === '') {
        miscControl.at(i).get('miscellaneous_amount').setErrors({'invalid':true});
        miscControl.at(i).get('miscellaneous_amount').markAsTouched();
        miscControl.at(i).get('miscellaneous_amount').markAsDirty();
      }
      });
    }


    validateSupplier.forEach((element,i) => {
      let validate = this._filter(this.formGroup.controls[element].value);
      if (validate) {
        if (validate[0] && (this.formGroup.controls[element].value.length != validate[0]['supplier'].length)) {
          // this.formGroup.controls[element].setValue('');
        } else if(validate.length == 0) {
          // this.formGroup.controls[element].setValue('');
        }
      }
    });

    this.formGroup.controls['travel_itinerary_details'].value.forEach((element,index) => {
      element.itinerary_detail_id = this.data.res.travel_itinerary_details[index].id;
    });
    if (this.data.mode == 0) {
      this.itineraryService.storeDetail(this.formGroup.getRawValue()).subscribe(res=>{
        this.loading = false;
        this.dialogRef.close(res['data'][0]);
      },(err => {
        this.loading = false;
        
        var arrayControl = this.formGroup.get('travel_itinerary_details') as FormArray;
        this.expensesList.forEach((element,i) => {
          if (arrayControl.at(i).get('vat').value == '') {
            arrayControl.at(i).get('vat').setErrors({'invalid':true});
            arrayControl.at(i).get('vat').markAsTouched();
            arrayControl.at(i).get('vat').markAsDirty();            
          }
          if (arrayControl.at(i).get('supplier').value == '') {
            arrayControl.at(i).get('supplier').setErrors({'invalid':true});
            arrayControl.at(i).get('supplier').markAsTouched();
            arrayControl.at(i).get('supplier').markAsDirty();         
          }
          if (arrayControl.at(i).get('amount').value == '') {
            arrayControl.at(i).get('amount').setErrors({'invalid':true});
            arrayControl.at(i).get('amount').markAsTouched();
            arrayControl.at(i).get('amount').markAsDirty();         
          }
        });

        this.travel.setErrors(err.error.errors);
        this.travel.triggerErrors(err.error.errors);

        var arrayControl = this.formGroup.get('travel_itinerary_details') as FormArray;
        this.expensesList.forEach((element,i) => {
          if (this.travel._errors['travel_itinerary_details.'+i+'.amount']) {
            arrayControl.at(i).get('amount').setErrors({'invalid':true});
            arrayControl.at(i).get('amount').markAsTouched();
            arrayControl.at(i).get('amount').markAsDirty();
          }
        });

        var miscControl = this.formGroup.get('misc') as FormArray;
        
        this.data.res.itinerary_miscellaneous.forEach((element,i) => {
          if (this.travel._errors['misc.'+i+'.miscellaneous_amount']) {
            miscControl.at(i).get('miscellaneous_amount').setErrors({'invalid':true});
            miscControl.at(i).get('miscellaneous_amount').hasError('422');
            miscControl.at(i).get('miscellaneous_amount').markAsTouched();
            miscControl.at(i).get('miscellaneous_amount').markAsDirty();
          }
        });
      }));
    } else {
      this.itineraryService.updateDetail(this.detail_id,this.formGroup.getRawValue()).subscribe(res=>{
        this.loading = false;
        this.dialogRef.close(res['data'][0]);
      },(err => {
        this.loading = false;
        this.travel.setErrors(err.error.errors);
        this.travel.triggerErrors(err.error.errors);

        var arrayControl = this.formGroup.get('travel_itinerary_details') as FormArray;
        this.expensesList.forEach((element,i) => {

          if (this.travel._errors['travel_itinerary_details.'+i+'.amount']) {
            arrayControl.at(i).get('amount').setErrors({'invalid':true});
            arrayControl.at(i).get('amount').markAsTouched();
            arrayControl.at(i).get('amount').markAsDirty();
          }
        });

        var miscControl = this.formGroup.get('misc') as FormArray;
        
        this.data.res.itinerary_miscellaneous.forEach((element,i) => {
          if (this.travel._errors['misc.'+i+'.miscellaneous_amount']) {
            miscControl.at(i).get('miscellaneous_amount').setErrors({'invalid':true});
            miscControl.at(i).get('miscellaneous_amount').hasError('422');
            miscControl.at(i).get('miscellaneous_amount').markAsTouched();
            miscControl.at(i).get('miscellaneous_amount').markAsDirty();
          }
        });

      }));
    }

  }


   supplierLookUp(i?:number,formInput?:string,mode?:string,index?:number){
    this.dialogConfig.width = '605px';
    this.dialogConfig.data = {
        i,
    }
    let dialogRef = this.dialog.open(LookUpLocationComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (formInput == 'supplier') {
          this.formGroup.controls['travel_itinerary_details'].patchValue([{
            supplier: result.value.supplier,
            tin:  result.value.tin,
          }]);
          this.tin_supplier[index] = result.value.tin;
        } else if (formInput == 'miscellaneous_supplier') {
          (<FormArray>this.formGroup.controls['misc']).at(index).patchValue({
            miscellaneous_supplier: result.value.supplier,
            miscellaneous_tin:  result.value.tin,
          });
          this.miscObj[index].miscellaneous_tin = result.value.tin;
        } else {
          this.formGroup.controls[formInput].setValue(result.value.supplier);
          let tinInput = formInput.replace('_supplier','_tin');
          this.formGroup.controls[tinInput].setValue(result.value.tin);
          this[tinInput] = result.value.tin;
        }
      }
    });
  }

  private _filter(name: string): string[] {
    if (name) {
      const filterValue = name.toLowerCase();
      return this.supplier.filter(option => option.supplier.toLowerCase().includes(filterValue)); 
    }
  }

}
